export enum SearchAnalyticsEnum {
  LEAD_SEARCH_NOTIFY_ME = '[PAC WEB] Resultado da busca - Formulário de avise-me',
  VIEW_SEARCH_RESULTS = '[PAC WEB] Resultado da busca - Página visualizada',
  CLICK_SEARCH_RESULT_AVATAR = '[PAC WEB] Resultado da busca - Clicou no avatar',
  CLICK_SEARCH_RESULT_PARTNER_NAME = '[PAC WEB] Resultado da busca - Clicou no nome do parceiro',
  CLICK_EXPAND_SEARCH_RESULT_ADDRESS = '[PAC WEB] Resultado da busca - Expandiu endereço',
  CLICK_OPEN_MAP_SEARCH_RESULT = '[PAC WEB] Resultado da busca - Clicou em "Abrir no mapa"',
  CLICK_SEE_MORE_SEARCH_RESULTS = '[PAC WEB] Resultado da busca - Clicou em "Ver mais resultados"',
  CLICK_SEARCH_RESULT_COVERAGE_VIEW = '[PAC WEB] Resultado da busca - Clicou em "Ver" cobertura de exames',

  VIEW_ARRIVAL_ORDER_MODAL = '[PAC WEB] Resultado da busca - Abriu modal de horários',
  CLICK_ARRIVAL_ORDER_DATE_NAV = '[PAC WEB] Resultado da busca - Navegou datas nos horários',
  CLICK_ARRIVAL_ORDER_SLOT = '[PAC WEB] Resultado da busca - Selecionou horário',
  CLOSE_ARRIVAL_ORDER_MODAL = '[PAC WEB] Resultado da busca - Fechou modal de horários',
  CLICK_SEE_OTHER_SCHEDULES = '[PAC WEB] Resultado da busca - Clicou em "Ver outros horários"',

  ACCEPTED_NEAR_SCHEDULE_WARNING = '[PAC WEB] Resultado da busca - Aceitou aviso de horário próximo',
  DISMISSED_NEAR_SCHEDULE_WARNING = '[PAC WEB] Resultado da busca - Fechou aviso de horário próximo',

  ACCEPTED_DIFFERENT_CITY_WARNING = '[PAC WEB] Resultado da busca - Aceitou aviso de localidade diferente do cadastro',
  DISMISSED_DIFFERENT_CITY_WARNING = '[PAC WEB] Resultado da busca - Fechou aviso de localidade diferente do cadastro',

  CLICK_ADD_STANDALONE_GUIDE = '[PAC WEB] Resultado da busca - Clicou em Adicionar guia avulsa',
  STANDALONE_SELECT_PATIENT = '[PAC WEB] Guia avulsa - Selecionou paciente',
  STANDALONE_ADD_TO_CART = '[PAC WEB] Guia avulsa - Adicionou ao carrinho',
  STANDALONE_CONFIRM_CONTACT = '[PAC WEB] Guia avulsa - Confirmou contato',

  SEARCH_SUGGESTION_TELEHEALTH_SHOWN = '[PAC WEB] Sugestões - Teleconsulta exibida',
  SEARCH_SUGGESTION_TELEHEALTH_OPTION_CLICKED = '[PAC WEB] Sugestões - Clicou em opção de teleconsulta',
  SEARCH_SUGGESTION_TELEHEALTH_SEE_ALL = '[PAC WEB] Resultado da busca - Sugestão Teleconsulta - Clicou em "Ver todos os profissionais"',

  SEARCH_SUGGESTION_NEAR_CITY_SHOWN = '[PAC WEB] Sugestões - Cidades próximas exibidas',
  SEARCH_SUGGESTION_NEAR_CITY_SELECTED = '[PAC WEB] Sugestões - Selecionou cidade próxima',
  SEARCH_SUGGESTION_NEAR_CITY_SEE_ALL = '[PAC WEB] Resultado da busca - Sugestão Cidades Próximas - Clicou em "Ver todos os profissionais"',

  SEARCH_SUGGESTION_CITY_BRANCH_SHOWN = '[PAC WEB] Sugestões - Unidade física exibida',
  SEARCH_SUGGESTION_CITY_BRANCH_SELECTED = '[PAC WEB] Sugestões - Clicou em unidade física',
  SEARCH_SUGGESTION_CITY_BRANCH_SEE_ALL = '[PAC WEB] Resultado da busca - Sugestão Unidades Físicas - Clicou em "Ver todas as unidades"',

  CLICK_SEARCH_RESULT_TAB_SCHEDULED = '[PAC WEB] Resultado da busca - Clicou na aba "Hora Marcada"',
  CLICK_SEARCH_RESULT_TAB_ARRIVAL_ORDER = '[PAC WEB] Resultado da busca - Clicou na aba "Ordem de chegada"',
  CLICK_SEARCH_RESULT_TAB_FLEX = '[PAC WEB] Resultado da busca - Clicou na aba "Flex"',
  CLICK_SEARCH_RESULT_TAB_WHATSAPP = '[PAC WEB] Resultado da busca - Clicou na aba "WhatsApp"',
  CLICK_SEARCH_RESULT_TAB_STANDALONE = '[PAC WEB] Resultado da busca - Clicou na aba "Guia avulsa"',

  SORT_OPEN_SELECTOR = '[PAC WEB] Ordenação - Abriu seletor de ordenação',
  SORT_SELECTED = '[PAC WEB] Ordenação - Selecionou ordenação',

  FILTERS_OPEN = '[PAC WEB] Filtros - Abriu modal de filtros',
  FILTERS_APPLIED = '[PAC WEB] Filtros - Aplicou filtros',
  FILTERS_CLEARED = '[PAC WEB] Filtros - Limpou filtros',
  FILTERS_CLEARED_ALL = '[PAC WEB] Filtros - Limpou tudo',
  FILTERS_NO_RESULTS_FOR_COMBINATION = '[PAC WEB] Filtros - Sem resultados para combinação',
}

export enum ScheduleTabOrigin {
  SEARCH_RESULTS = 'resultado_busca',
  PARTNER_PROFILE = 'perfil_clinica',
  PROFESSIONAL_PROFILE = 'perfil_profissional',
}

export const STANDALONE_GUIDE_SCHEDULE_TYPE = 'GUIA_AVULSA';

export type AnalyticsScheduleType = typeof STANDALONE_GUIDE_SCHEDULE_TYPE;
